import { Route } from 'react-router-dom'

import { ScoutConfirmationPage } from '../pages'

export const schedulingRoutes = (
  <Route path="/scheduling">
    <Route path="scout" element={<ScoutConfirmationPage />} />
  </Route>
)

export default schedulingRoutes
